import { color } from "@chakra-ui/react";

export default {
    /* Container */
    rssContainer: {
        maxWidth: {lg: '690px'},
        margin: {lg: '0 auto'},
        paddingX: {base: 4, lg: 0},
        paddingY: {base: 12}
    },

    /* Greeting title */
    rssTitle: {
        textStyle: 'webH1',
        marginBottom: 6,
        textAlign: 'center'
    },

    /* QR code row — mobile only */
    rssQrRow: {
        display: {base: 'flex', lg: 'none'},
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        marginBottom: '26px',
        cursor: 'pointer'
    },
    rssQrCode: {
        textStyle: 'bodySmRegular'
    },

    /* Collectif status label + value */
    rssStatusLabel: {
        textStyle: 'bodyXsRegular',
        color: 'webTypo.textSecondary',
        marginBottom: 1
    },
    rssStatusValue: {
        textStyle: 'webH3',
        marginBottom: 4
    },

    /* Loyalty progress bar + tier labels */
    loyaltyStatus: {
        progressBarContainer: {
            marginTop: {base: 4, lg: 3}
        },
        progressBarWrapper: {
            position: 'relative',
            height: {base: '6px'},
            backgroundColor: 'webBasic.400',
            overflow: 'hidden',
            zIndex: '1'
        },
        progressFill: {
            height: '100%',
            backgroundColor: 'webTheme.strokeInteractive',
            transition: 'width 0.5s ease-in-out'
        },
        labelsRow: {
            alignItems: 'center',
            justify: 'space-between',
            marginTop: {base: 1},
            marginBottom: {base: 3},
            minHeight: {base: '20px'}
        },
        labelWrapper: {
            position: 'relative',
            textAlign: 'center',
            flex: 1
        },
        labelText: {
            textStyle: 'labelXs'
        },
        arrow: {
            position: 'absolute',
            top: {base: '-13px', lg: '-26px'},
            width: {base: '10px', lg: '18px'},
            height: {base: '10px', lg: '18px'},
            backgroundColor: 'brandMagenta'
        },
        arrowLeft: {
            left: {base: '9px'},
            transform: 'translateX(0) rotate(45deg)'
        },
        arrowRight: {
            right: {base: '9px'},
            transform: 'translateX(0) rotate(45deg)'
        },
        arrowCenter: {
            left: '50%',
            transform: 'translateX(-50%) rotate(45deg)'
        }
    },

    /* Footer — missing points + earn before */
    rssFooterMissingPoints: {
        textStyle: 'bodySmRegular',
        color: 'webTypo.textSecondary'
    },
    rssFooterEarnBefore: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        textStyle: 'bodyXsRegular',
        color: 'webTypo.textSecondary'
    },

    /* Points history CTA */
    rssPointsHistory: {
        display: 'inline-block',
        cursor: 'pointer',
        textStyle: 'bodySmLink',
        marginTop: 2
    },

    /* Tooltip drawer */
    rssTooltipTitle: {
        textStyle: 'webH2',
        marginBottom: 6
    },
    rssTooltipText: {
        textStyle: 'bodySmRegular'
    },

    /* History points drawer */
    rssDrawerPoints: {
        textStyle: 'largeTitle2',
        fontWeight: 'bold'
    },
    rssDrawerResetDate: {
        textStyle: 'bodySmRegular',
        marginBottom: 6
    },
    rssDrawerDate: {
        textStyle: 'bodyXsRegular',
        marginBottom: 1,
        color: 'webTypo.textSecondary'
    },
    rssDrawerCard: {
        padding: 3,
        backgroundColor: 'webTheme.backgroundPrimaryBrand',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    rssDrawerCardText: {
        textStyle: 'bodyMdRegular',
        marginRight: 0
    },
    rssDrawerCardPoints: {
        textStyle: 'bodyMdRegular',
        minWidth: 24,
        textAlign: 'right'
    },
    rssDrawerList: {
        gap: 6
    }
}
